import { render, staticRenderFns } from "./billing-modal-delivery-notes-add-to.vue?vue&type=template&id=fff1aea4&scoped=true&"
import script from "./billing-modal-delivery-notes-add-to.ts?vue&type=script&lang=ts&"
export * from "./billing-modal-delivery-notes-add-to.ts?vue&type=script&lang=ts&"
import style0 from "./billing-modal-delivery-notes-add-to.scss?vue&type=style&index=0&id=fff1aea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff1aea4",
  null
  
)

export default component.exports